import dayjs from './date.js';

export function formatVersionStamp (uploadedAt) {
	if (!uploadedAt) {
		return '—';
	}
	const parsed = dayjs(uploadedAt);
	return parsed.isValid() ? parsed.format('DD-MMM-YYYY HH:mm') : String(uploadedAt);
}

export function formatVersionLabel (version) {
	if (!version) {
		return 'Untitled';
	}
	if (version.label) {
		return version.label;
	}
	return version.filename || 'Untitled';
}

function filenameKey (version) {
	return String((version && (version.filename || version.label)) || '').toLowerCase();
}

export function duplicateFilenameIds (versions) {
	const counts = {};
	(versions || []).forEach(version => {
		const key = filenameKey(version);
		if (!key) {
			return;
		}
		counts[key] = (counts[key] || 0) + 1;
	});
	const duplicates = {};
	(versions || []).forEach(version => {
		const key = filenameKey(version);
		if (key && counts[key] > 1 && version && version.id != null) {
			duplicates[String(version.id)] = true;
		}
	});
	return duplicates;
}

/**
 * Unique identity for selectors, table rows, and accessible names.
 * Always includes upload timestamp; adds version id when filenames collide.
 */
export function formatVersionIdentity (version, options = {}) {
	const name = formatVersionLabel(version);
	const stamp = formatVersionStamp(version && version.uploadedAt);
	const duplicate = !!(options.duplicate);
	const includeId = duplicate || options.alwaysIncludeId;
	const idPart = includeId && version && version.id != null ? ` · #${version.id}` : '';
	return `${name} · ${stamp}${idPart}`;
}

export function formatVersionOptionLabel (version, options = {}) {
	const identity = formatVersionIdentity(version, options);
	const kind = version && version.isBaseline
		? 'Baseline'
		: (version && version.sourceFormat === 'mspdi' ? 'MS Project XML' : 'P6 XER');
	return `${identity} · ${kind}`;
}

export function formatVersionAccessibleName (role, version, options = {}) {
	const identity = formatVersionIdentity(version, options);
	return role ? `${role} ${identity}` : identity;
}
